<template>
<div class="row">
    <q-card class="" style="width:100%" name="customerHolder">
      <q-card-section>
        <div class="row">
          <div class="col">
            <a class="text-subtitle2">Investor Name</a>
            <br />
            <a class="text-caption">{{CustomerName}}</a>
          </div>
          <div class="col">
            <a class="text-subtitle2">Account Id</a>
            <br />
            <a class="text-caption">{{CustomerAccountId}}</a>
          </div>
          <div class="col">
            <a class="text-subtitle2">Account Type</a>
            <br />
            <a class="text-caption">{{CustomerFundType}}</a>
          </div>
        </div>
      </q-card-section>
    </q-card>
</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      CustomerName: state => state.CD.CustomerDetails.CustomerName,
      CustomerAccountId: state => state.CD.Account.AccountId,
      CustomerFundType: state => state.CD.Account.AccountType
  })
  },
  methods: {
    ...mapActions([])
  },
  mounted(){
  }
};
</script>